import { FUNCTION_CODE } from '~/common/constants/functionCode'
import ListProfileCustom from '~/modules/master/features/profile-custom/list'
const route = {
  path: '/',
  component: ListProfileCustom,
  code: FUNCTION_CODE.USER_LIST_PROFILE_CUSTOM,
}

export default route
